/* eslint-disable indent */
'use strict';
import './tasks.scss';

import angular from 'angular';
import * as Config from 'config';
import * as moment from 'moment';
import SimpleMessages from 'app/controllers/simple-messages';
import ngAsync from 'app/async/async.function.decorator';

import AddTaskController from './add-task.controller';
import AddTaskTpl from './add-task.html';

import ChangeDueDateController from './change-due-date.controller';
import ChangeDueDateTpl from './change-due-date.html';

import CompleteController from './complete.controller';
import CompleteTpl from './complete.html';


interface CalendarDay {
  date: moment.Moment;
  dayName: string;
  dayTasks: any[];
}


export default class TasksController {
  static $inject = [
    'TasksService',
    'EmployeesService',
    'OperationsService',
    'LoginService',
    'OrderTranslationService',
    '$mdDialog',
    '$mdToast',
    '$scope',
    '$q',
    '$window',
    'LoopBackAuth',
    '$state',
    '$stateParams'
  ];
  TasksService;
  EmployeesService;
  OperationsService;
  LoginService;
  OrderTranslationService;
  query = {};
  tasks: any[] = [];
  tasksCount: number;
  $scope: any;
  $mdDialog: any;
  $mdToast: any;
  $window: any;
  LoopBackAuth: any;
  $stateParams: any;
  $state: any;

  employee: any;
  dueDate: any;
  registry: any;
  status: string = 'non-completed';

  searchEmployeeText: string = '';

  isSelectedAnyTask: boolean = false;

  onPagination = (): Promise<void> => this.getTasks();
  onReorder = (): Promise<void> => this.getTasks();
  mdOrder: string = 'dueDate';
  showSpin: boolean = false;
  calendarDays: CalendarDay[] = [];
  isCalendarMode: boolean = false;

  clsPrefix = 'tasks';

  constructor(
    TasksService,
    EmployeesService,
    OperationsService,
    LoginService,
    OrderTranslationService,
    $mdDialog,
    $mdToast,
    $scope,
    $q,
    $window,
    LoopBackAuth,
    $state,
    $stateParams,
  ) {
    Object.assign(this, {
      TasksService,
      EmployeesService,
      OperationsService,
      LoginService,
      OrderTranslationService,
      $mdDialog,
      $mdToast,
      $scope,
      $q,
      $window,
      LoopBackAuth,
      $state
    });

    $scope.selectedTasks = {};
    $scope.$watch(
      'selectedTasks',
      (newlySelected: any) => {
        if (!newlySelected) {
          return;
        }
        this.isSelectedAnyTask =
          Object.keys(newlySelected).filter(a => newlySelected[a]).length > 0
          ? true
          : false;
      },
      true
    );

    this.employee = $scope.$parent.$resolve.user.employee;

    this.query = {
      limit: 50,
      page: 1,
      where: {},
      include: [
        {
          relation: 'createdByUser',
          scope: {
            include: ['employee']
          }
        },
        {
          relation: 'operation',
          scope: {
            include: ['holder', 'vehicle', 'operationType', 'agency']
          }
        },
        'employee',
      ]
    };
    this.getTasks();

    const { action, operationId } = $stateParams;
    if (action == 'create' && operationId) {
      this.$state.go('tasks', {action: '', operationId: ''},  {notify: false, location: 'replace'});
      this.createForOperation(operationId);
    }
  }

  queryEmployeeSearch(text) {
    return this.EmployeesService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });
  }

  @ngAsync()
  async createForOperation(operationId) {
    const operation = await this.OperationsService.findById(operationId, {
      include: ['holder', 'vehicle', 'operationType', 'agency']
    });
    await this.addTask(operation);
  }

  @ngAsync()
  async getTasks(): Promise<void> {
    const isCalendarMode = this.isCalendarMode;
    const opts = JSON.parse(JSON.stringify(this.query));


    let wheres = [];
    if (this.employee) {
      wheres.push({
        employeeId: this.employee.id
      });
    }
    if (this.status) {
      if (this.status == 'completed') {
        wheres.push({
          completedAt: {
            neq: null
          }
        });
      } else if (this.status == 'non-completed') {
        wheres.push({
          completedAt: {
            eq: null
          }
        });
      }
    }
    if (isCalendarMode) {
      // Get the whole week dueDate belongs to
      const [startDate, endDate] = this.getDateRange();
      wheres.push({
        dueDate: {
          gt: startDate
        }
      });
      wheres.push({
        dueDate: {
          lt: endDate
        }
      });
    } else {
      if (this.dueDate) {
        wheres.push({
          dueDate: this.dueDate
        });
      }
    }
    opts.where.and = wheres;
    if (this.mdOrder) {
      opts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    this.showSpin = true;
    this.tasks = await this.TasksService.getModels(opts);
    this.tasksCount = (
      await this.TasksService.getCount(opts)
    ).count;
    this.updateCalendarData();
    this.showSpin = false;

  }

  @ngAsync()
  async addTask(operation: any) {
    const user = await this.LoginService.getCurrent();
    // const suggestedEmployee = this.employee && this.employee.id != user.employee.id ? this.employee : user.employee;
    const data = await this.$mdDialog.show({
      controller: AddTaskController,
      template: AddTaskTpl,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      locals: {
        // suggestedEmployee,
        operation
      }
    });

    await this.TasksService.createMulti(
      data.employees.map(e => e.id),
      data.description,
      data.date,
      data.operation ? data.operation.id : null
    );

    this.getTasks();
  }

  onToggleTask(task: object) {
  }

  @ngAsync()
  async onChangeDueDateClick() {
    const ids = Object.keys(this.$scope.selectedTasks)
      .filter(id => this.$scope.selectedTasks[id]);
    if (!ids) {
      return;
    }

    const data = await this.$mdDialog.show({
      controller: ChangeDueDateController,
      template: ChangeDueDateTpl,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      locals: {
        ids
      }
    });

    const { date } = data;
    await this.TasksService.changeDueDate(
      ids,
      date
    );

    this.getTasks();
  }

  updateCalendarData() {
    if (!this.isCalendarMode) {
      return;
    }

    const [startDate, endDate] = this.getDateRange();
    const data: CalendarDay[] = [];
    const indexDate = startDate.clone();
    while (indexDate.isSameOrBefore(endDate)) {
      const date = indexDate.clone();
      indexDate.add(1, 'days');
      const dayName = date.format('dddd');
      if (dayName === 'domingo') {
        continue;
      }

      const dayTasks = this.tasks.filter(
        t => moment(t.dueDate).isSame(date, 'day')
      );

      const dayNameLabel = `${dayName.charAt(0).toUpperCase() + dayName.slice(1)} \
${date.format('D/M')}`;

      data.push({
        date,
        dayName: dayNameLabel,
        dayTasks
      });
      date.add(1, 'days');
    }

    this.calendarDays = data;
  }

  @ngAsync()
  async onCompleteClick() {
    const ids = Object.keys(this.$scope.selectedTasks)
      .filter(id => this.$scope.selectedTasks[id]);
    if (!ids) {
      return;
    }

    const data = await this.$mdDialog.show({
      controller: CompleteController,
      template: CompleteTpl,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      locals: {
        ids
      }
    });

    const { comments } = data;

    await this.TasksService.complete(
      ids,
      comments
    );

    this.getTasks();
  }

  getDateRange(): [moment.Moment, moment.Moment] {
    const startDate = moment(this.dueDate).startOf('week');
    const endDate = moment(this.dueDate).endOf('week');

    return [startDate, endDate];
  }

  @ngAsync()
  async onCalendarSelect() {
    this.isCalendarMode = true;
    await this.getTasks();
  }

  onListSelect() {
    this.isCalendarMode = false;
    this.getTasks();
  }
}
